import { Poster } from "../types/Poster";

export const POSTERS: Poster[] = [
    {
        title: "1887",
        route: "/trophy",
        imageUrl: "/images/poster/hsv-champ.jpg",
        overviewImageUrl: "/images/poster/hsv-champ.jpg",
        videoUrl: "/videos/trophy.mp4",
        year: "2026",
    },
    {
        title: "HSV FLAMES",
        route: "/flames",
        imageUrl: "/images/poster/hsv-flames.jpg",
        overviewImageUrl: "/images/poster/hsv-flames.jpg",
        videoUrl: "/videos/flames.mp4",
        year: "2026",
    },
    {
        title: "VAN DER VAART",
        route: "/van-der-vaart",
        imageUrl: "/images/poster/van-der-vaart.jpg",
        overviewImageUrl: "/images/poster/van-der-vaart.jpg",
        videoUrl: "/videos/van-der-vaart.mov",
        year: "2026",
    },
    {
        title: "VUSKOVIC",
        route: "/vuskovic",
        imageUrl: "/images/poster/vuskovic.jpg",
        overviewImageUrl: "/images/poster/vuskovic.jpg",
        videoUrl: "/videos/vuskovic.mp4",
        year: "2026",
    },
];

export function getPosterByRoute(route: string): Poster | undefined {
    return POSTERS.find((p) => p.route === route);
}
